import t from"./find-facets-in-string.js";import{groupFacets as e}from"./group-facets.js";function c(r){const o=t(r);return e(o)}export{c as default};
//# sourceMappingURL=group-facets-from-string.js.map
